import { useContext, useEffect, useRef, useState } from 'react';
import Page from '../../../layout/Page/Page';
import Card, {
    CardActions,
    CardBody,
    CardHeader,
    CardLabel,
    CardTitle,
} from '../../bootstrap/Card';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Select from '../../bootstrap/forms/Select';
import { toasts } from '../../../services/toast.service';
import Button, { ButtonGroup } from '../../bootstrap/Button';
import Collapse from '../../bootstrap/Collapse';
import Icon from '../../icon/Icon';
import useDarkMode from '../../../hooks/useDarkMode';
import PaginationButtons, { dataPagination } from '../../PaginationButtons';
import Dropdown, { DropdownToggle, DropdownMenu, DropdownItem } from '../../bootstrap/Dropdown';
import Checks, { ChecksGroup } from '../../bootstrap/forms/Checks';
import Input from '../../bootstrap/forms/Input';
import { useReactToPrint } from 'react-to-print';
import useSortableData from '../../../hooks/useSortableData';
import { useFormik } from 'formik';
import OpenCardComponent from '../../../common/components/OpenCardComponent';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import { convertJsonToPdf, downloadExcel, downloadFile } from '../../../services/ExportService';
import { getAdmissionAbstractReport, getOverAllStrengthReport } from '../../../services/report.service';
import AuthContext from '../../../contexts/authContext';
import {
    convertDateToEpoch,
    getColumnsForDataTable,
    getGraduationType,
    updateColumnsForDataTable,
    updateFilter,
} from '../../../services/common.service';
import { getLicenseKey } from '../../../services/application.settings';
import { getAcademicPeriod } from '../../../services/master.service';
import NoDataMsg from '../../../common/components/NoDataMsg';
import SearchableSelect from '../../../common/components/SearchableSelect';
import dayjs from 'dayjs';

function AdmissionAbstractReport() {

    useEffect(() => {
        getGraduationList();
        getAcademicPeriodList();
    }, []);

    const { userAccountId, userTypeId } = useContext(AuthContext);
    const { themeStatus, darkModeStatus } = useDarkMode();
    const [overAllStrengthData, setOverAllStrengthData] = useState<any>([]);
    const [dataSuccess, setDataSuccess] = useState(false);
    const [graduationTypeId, setGraduationTypeId] = useState<any>('');
    const [academicPeriodId, setAcademicPeriodId] = useState<any>('');
    const [academicPeriodData, setAcademicPeriodData] = useState<any>([]);
    const [graduationTypeData, setGraduationTypeData] = useState<any>([]);
    const [isOpenListCard, setIsOpenListCard] = useState(true);

    const [columnVisibilityData, setColumnVisibilityData] = useState<any>([]);
    const [allColumnsData, setAllColumnsData] = useState([]);
    const [columnVisibilityMenu, setColumnVisibilityMenu] = useState(false);
    const [columnDataById, setColumnDataById] = useState([]);
    const componentRef = useRef(null);
    const [isChecked, setIsChecked] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const { items, requestSort, getClassNamesFor } = useSortableData(overAllStrengthData);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);
    const [isLoader, setIsLoader] = useState(false);

    const [noDataMsg, setNoDataMsg] = useState('');

    const columnVisibilityForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            searchInput: '',
            available: false,
        },
        validate: (values) => { },

        //validateOnChange: false,
        onSubmit: () => { },
    });

    // Filter
    const filteredData = updateFilter(
        onCurrentPageData,
        columnVisibilityData,
        columnVisibilityForm,
    );


    const studentAttendanceForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            fromDate: dayjs().format('YYYY-MM-DD'),
            toDate: dayjs().format('YYYY-MM-DD'),
        },
        validate: (values) => {
            const errors: {
                fromDate?: string;
                toDate?: string;
            } = {};

            if (!values.fromDate) {
                errors.fromDate = "Required"
            }
            if (!values.toDate) {
                errors.toDate = "Required"
            }
            return errors;
        },

        //validateOnChange: false,
        onSubmit: () => { },
    });

    const selectAcademicPeriod = (e: any) => {
        setIsOpenListCard(true);
        setDataSuccess(false);
        setGraduationTypeId('');
        let academicPeriodId = e;
        setAcademicPeriodId(academicPeriodId);
    };
    const selectGraduationType = (e: any) => {
        setIsOpenListCard(true);
        setDataSuccess(false);
        let graduationTypeId = e;
        setGraduationTypeId(graduationTypeId);
    };

    function view() {
        setDataSuccess(false);
        setIsLoader(true);
        columnVisibilityForm.resetForm();

        // let fromDate = studentAttendanceForm.values.fromDate
        // let fromDateInMilleSec = convertDateToEpoch(fromDate)

        // let toDate = studentAttendanceForm.values.toDate
        // let toDateInMilleSec = convertDateToEpoch(toDate)

        getOverAllStrength(academicPeriodId?.value, graduationTypeId?.value);
    }

    function getAcademicPeriodList() {
        getAcademicPeriod(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.academicPeriod;
                    if (data != undefined) {
                        setAcademicPeriodData(data);
                    } else {
                        toasts('Undefined Data', 'Error');
                    }
                } else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setAcademicPeriodData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, 'Error');
                }
            },
            (error) => {
                toasts(error, 'Error');
            },
        );
    }

    function getGraduationList() {
        getGraduationType(
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.graduationType;
                    if (data != undefined) {
                        setGraduationTypeData(data);
                    } else {
                        toasts('Undefined Data', 'Error');
                    }
                } else if (response.data.success === false) {
                    //toasts(response.data.message, "Error")
                    setGraduationTypeData([]);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, 'Error');
                }
            },
            (error) => {
                toasts(error, 'Error');
            },
        );
    }

    const [particularDate, setParticularDate] = useState('')
    const [admission, setAdmission] = useState('')
    const [totalCapacity, setTotalCapacity] = useState<any>(0)
    const [totalAdmissionsPerRow, setTotalAdmissionsPerRow] = useState<any>([]);
    const [totalAdmissionsPerColumn, setTotalAdmissionsPerColumn] = useState<any>([]);
    const [total, setTotal] = useState<any>('')
    const [report, setReport] = useState<any>([])
    const [report1, setReport1] = useState<any>([])


    function getOverAllStrength(academicPeriodId: any, graduationTypeId: any) {
        setIsLoader(true);
        getAdmissionAbstractReport(academicPeriodId, graduationTypeId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.admissionAbstractReport;
                    if (data != undefined) {
                        setIsLoader(false);
                        setIsOpenListCard(false);
                        setDataSuccess(true);
                        setOverAllStrengthData(data);

                        const transformedData = data.reduce((acc: any, current: any) => {
                            const { courseId, courseName, totalAllocated, dateOfAdmission, admissionCount } = current;

                            let entry = acc.find((item: any) => item.courseId === courseId);

                            if (!entry) {
                                entry = { courseId, courseName, totalAllocated, dateOfAdmission, admissionCount: 0 };
                                acc.push(entry);
                            }
                            entry.admissionCount += admissionCount;

                            entry[dateOfAdmission] = (entry[dateOfAdmission] || 0) + admissionCount;

                            return acc;
                        }, []);

                        let capacityData: any[] = [];
                        let uniqueData1 = [];
                        let courseIds = new Set();
                        let dateOfAdmissions = new Set();

                        for (let i = 0; i < data.length; i++) {
                            let particular = data[i].dateOfAdmission
                            let ad = data[i].admissionCount
                            setParticularDate(particular)
                            setAdmission(ad)
                        }

                        for (let i = 0; i < data.length; i++) {
                            if (!dateOfAdmissions.has(data[i].dateOfAdmission)) {
                                dateOfAdmissions.add(data[i].dateOfAdmission);
                                capacityData.push(data[i]);
                            }
                        }

                        for (let i = 0; i < data.length; i++) {
                            if (!courseIds.has(data[i].courseId)) {
                                courseIds.add(data[i].courseId);
                                uniqueData1.push(data[i]);
                            }
                        }

                        for (let i = 0; i < transformedData.length; i++) {
                            transformedData[i].sno = i + 1;
                        }

                        const totalCapacity = uniqueData1.reduce((sum: any, row: any) => sum + row.totalAllocated, 0);
                        setTotalCapacity(totalCapacity)

                        let rowTotals: any[] = [];
                        let columnTotals: any = {};

                        let uniqueData = capacityData.filter((item: any) => item.dateOfAdmission != null)

                        uniqueData.forEach((dateOfAdmissionData: any) => { columnTotals[dateOfAdmissionData.dateOfAdmission] = 0 });

                        uniqueData1.forEach((rowData: any) => {
                            let rowTotal = 0;

                            uniqueData.forEach((dateOfAdmissionData: any) => {
                                const admissionData = data.find(
                                    (rowData1: any) => rowData1.courseId === rowData.courseId &&
                                        rowData1.dateOfAdmission === dateOfAdmissionData.dateOfAdmission
                                );

                                const admissionCount = admissionData ? admissionData.admissionCount : 0;
                                rowTotal += admissionCount;
                                columnTotals[dateOfAdmissionData.dateOfAdmission] += admissionCount;
                            });

                            rowTotals.push(rowTotal);
                        });

                        setTotalAdmissionsPerRow(rowTotals);
                        setTotalAdmissionsPerColumn(columnTotals);

                        const total: any = Object.values(columnTotals).reduce((a: any, b: any) => a + b, 0);
                        setTotal(total)

                        let data1: any = []

                        uniqueData.forEach((dateOfAdmissionData: any, index: any) => {
                            data1.push({ columnVisibilityId: index + 1, columnName: dateOfAdmissionData.dateOfAdmission, keyName: dateOfAdmissionData.dateOfAdmission, isActive: true, isDisplay: true, isDefault: true });
                        });

                        let finalData = data1.filter((item: any) => item.columnName != null)

                        const fin = [{ columnVisibilityId: 1, columnName: 'Course', keyName: 'courseName', isActive: true, isDisplay: true, isDefault: true }, { columnVisibilityId: 2, columnName: 'Capacity', keyName: 'totalAllocated', isActive: true, isDisplay: true, isDefault: true }]

                        const last = [{ columnVisibilityId: 3, columnName: 'Total', keyName: 'admissionCount', isActive: true, isDisplay: true, isDefault: true }]

                        setColumnVisibilityData([...fin, ...finalData, ...last])

                        console.log('uniqueData', uniqueData);
                        console.log('transformedData', transformedData);


                        setReport(uniqueData);
                        setReport1(transformedData);

                    } else {
                        setIsLoader(false);
                        toasts('Undefined Data', 'Error');
                    }
                } else if (response.data.success === false) {
                    setIsLoader(false);
                    setColumnVisibilityData([]);
                    setNoDataMsg(response.data.message);
                    setIsOpenListCard(false);
                    setDataSuccess(true);
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    setIsLoader(false);
                    toasts(errorDescription, 'Error');
                }
            },
            (error) => {
                setIsLoader(false);
                toasts(error, 'Error');
            },
        );
    }

    function getColumnsForTable(apiName: any, type: any) {
        getColumnsForDataTable(
            userTypeId,
            apiName,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.columnsForDataTable;
                    if (data != undefined) {
                        let allColumnsData = data;
                        setAllColumnsData(allColumnsData);
                        let columnVisibilityData = allColumnsData.filter(
                            (item: any) => item.isDisplay == 1,
                        );
                        setColumnVisibilityData(columnVisibilityData);

                        if (type == 'get') {
                            const allData = allColumnsData.map((item: any) => item.isDisplay);
                            const allColumns = allData.filter((item: any) => item == false);
                            setIsChecked(allColumns == '' ? true : false);
                        } else if (type == 'post') {
                            const all = [];
                            let nonDefaultValue = allColumnsData.filter(
                                (item: any) => item.isDefault == false,
                            );

                            for (let i = 0; i < nonDefaultValue.length; i++) {
                                const obj = {
                                    columnVisibilityId: nonDefaultValue[i].columnVisibilityId,
                                    isDisplay: nonDefaultValue[0].isDisplay == 0 ? 1 : 0,
                                };
                                all.push(obj);
                            }
                            updateColumnsSubmit('', '', all);
                        }
                    } else {
                        toasts('Undefined Data', 'Error');
                    }
                } else if (response.data.success === false) {
                    toasts(response.data.message, 'Error');
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, 'Error');
                }
            },
            (error) => {
                toasts(error, 'Error');
            },
        );
    }

    function updateColumnsSubmit(columnVisibilityId: any, isDisplay: any, type: any) {
        if (columnVisibilityForm.isValid) {
            setColumnDataById(isDisplay);
            const columnVisibilityPostData = {
                licenseKey: getLicenseKey,
                userAccountId: userAccountId,
                columns: type
                    ? type
                    : [
                        {
                            columnVisibilityId: columnVisibilityId,
                            isDisplay: isDisplay ? 0 : 1,
                        },
                    ],
            };

            updateColumnsForDataTable(
                columnVisibilityPostData,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        getColumnsForTable('getOverAllStrengthReport', 'get');
                    } else if (data.success == false) {
                        // toasts(data.success, "Error")
                    } else {
                        let errorCode = response.data.error[0].error_code;
                        let errorDescription = response.data.error[0].error_description;
                        toasts(errorDescription, 'Error');
                    }
                },
                (error) => {
                    toasts(error, 'Error');
                },
            );
        } else if (columnVisibilityForm.isValid == false) {
            toasts('Please fill all the details!', 'Error');
        }
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (

        <PageWrapper title='Over All Strength'>
            <Page container='fluid'>
                <Collapse isOpen={isOpenListCard}>
                    <Card stretch data-tour='list'>
                        <CardHeader borderSize={1}>
                            <CardLabel icon='List' iconColor='info' className='col-lg-6'>
                                <CardTitle tag='div' className='h5'>
                                    Admission Abstract Report
                                </CardTitle>
                            </CardLabel>
                        </CardHeader>
                        <CardBody>
                            <div className='row'>
                                {/* <div className='col-3'>
                                    <FormGroup id='fromDate' label='Date' isFloating>
                                        <Input onChange={studentAttendanceForm.handleChange}
                                            value={studentAttendanceForm.values.fromDate}
                                            onBlur={studentAttendanceForm.handleBlur}
                                            isValid={studentAttendanceForm.isValid}
                                            isTouched={studentAttendanceForm.touched.fromDate}
                                            invalidFeedback={studentAttendanceForm.errors.fromDate}
                                            type='date' />
                                    </FormGroup>
                                </div>
                                <div className='col-3'>
                                    <FormGroup id='toDate' label='Date' isFloating>
                                        <Input onChange={studentAttendanceForm.handleChange}
                                            value={studentAttendanceForm.values.toDate}
                                            onBlur={studentAttendanceForm.handleBlur}
                                            isValid={studentAttendanceForm.isValid}
                                            isTouched={studentAttendanceForm.touched.toDate}
                                            invalidFeedback={studentAttendanceForm.errors.toDate}
                                            type='date' />
                                    </FormGroup>
                                </div> */}
                                {/* {academicPeriodId?.value != undefined ? */}

                                <div className='col-3'>
                                    <FormGroup
                                        id='academicPeriod'
                                        label='Academic Period'
                                        isFloating>
                                        <SearchableSelect
                                            isFloating
                                            ariaLabel='Academic Period'
                                            onChange={selectAcademicPeriod}
                                            value={academicPeriodId}
                                            list={academicPeriodData.map((data: any) => ({
                                                value: data.academicPeriodId,
                                                label: data.period,
                                            }))}
                                        />
                                    </FormGroup>
                                </div>
                                <div className='col-3'>
                                    <FormGroup
                                        id='graduationTypeId'
                                        label='Graduation Type'
                                        isFloating>
                                        <SearchableSelect
                                            isFloating
                                            ariaLabel='Graduation Type'
                                            onChange={selectGraduationType}
                                            value={graduationTypeId}
                                            list={graduationTypeData.map((data: any) => ({
                                                value: data.graduationTypeId,
                                                label: data.graduationType,
                                            }))}
                                        />
                                    </FormGroup>
                                </div> {/*: null} */}
                                {/* {graduationTypeId?.value != undefined ? */}
                                <div className='col-3 align-self-center'>
                                    <Button icon='ArrowDownward' color='primary' isDisable={academicPeriodId?.value == undefined || graduationTypeId?.value == undefined ? true : false} onClick={view}>
                                        View
                                    </Button>
                                </div>
                                {/* : null} */}
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>

                <OpenCardComponent
                    isOpenListCard={isOpenListCard}
                    setIsOpenListCard={setIsOpenListCard}
                    isLoader={isLoader}
                />

                {dataSuccess ? (
                    <Card stretch data-tour='list' ref={componentRef} id='pdf'>
                        <CardHeader borderSize={1}>
                            <CardLabel icon='List' iconColor='info' className='col-lg-7'>
                                <CardTitle tag='div' className='h5'>
                                    Admission Abstract Report
                                </CardTitle>
                            </CardLabel>
                            {/* &nbsp;&nbsp;
                            <ButtonGroup
                                className='col-lg-3 justify-content-end d-print-none'
                                color='primary'>
                                <Icon className='mt-1' icon='Search' size='2x' color='primary' />
                                <Input
                                    id='searchInput'
                                    type='search'
                                    placeholder='Search...'
                                    onChange={columnVisibilityForm.handleChange}
                                    value={columnVisibilityForm.values.searchInput}
                                />
                            </ButtonGroup> */}
                            <CardActions className='d-print-none'>
                                {/* <Dropdown
                                    isOpen={columnVisibilityMenu}
                                    setIsOpen={setColumnVisibilityMenu}
                                    isButtonGroup>
                                    <DropdownToggle>
                                        <Button icon='FilterAlt' color='primary' isLight>
                                            Filter
                                        </Button>
                                    </DropdownToggle>
                                    <DropdownMenu
                                        isAlignmentEnd
                                        size='lg'
                                        isCloseAfterLeave={false}>
                                        <DropdownItem>
                                            <div className='container py-2'>
                                                <form className='row g-3'>
                                                    <div className='col-12'>
                                                        <FormGroup>
                                                            <h6>Select All</h6>
                                                            <Checks
                                                                id='available'
                                                                type='switch'
                                                                label='Select All Columns'
                                                                onChange={() =>
                                                                    getColumnsForTable(
                                                                        'getOverAllStrengthReport',
                                                                        'post',
                                                                    )
                                                                }
                                                                checked={isChecked}
                                                                ariaLabel='Available status'
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div
                                                        className='col-12'
                                                        style={{
                                                            maxHeight: '200px',
                                                            overflowY: 'scroll',
                                                        }}>
                                                        <FormGroup>
                                                            <h6>Columns</h6>
                                                            <ChecksGroup>
                                                                {allColumnsData.map((i: any) => (
                                                                    <Checks
                                                                        key={i.columnVisibilityId}
                                                                        id='{i.columnVisibilityId}'
                                                                        label={i.columnName}
                                                                        onChange={() =>
                                                                            updateColumnsSubmit(
                                                                                i.columnVisibilityId,
                                                                                i.isDisplay,
                                                                                '',
                                                                            )
                                                                        }
                                                                        checked={i.isDisplay}
                                                                        disabled={
                                                                            i.isDefault == true
                                                                        }
                                                                    />
                                                                ))}
                                                            </ChecksGroup>
                                                        </FormGroup>
                                                    </div>
                                                </form>
                                            </div>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                                <Dropdown isButtonGroup>
                                    <DropdownToggle>
                                        <Button color='primary' isLight icon='CloudDownload'>
                                            {' '}
                                            Export{' '}
                                        </Button>
                                    </DropdownToggle>
                                    <DropdownMenu isAlignmentEnd>
                                        <DropdownItem>
                                            <Button
                                                color='primary'
                                                isLight
                                                icon='CloudDownload'
                                                onClick={() =>
                                                    downloadExcel(
                                                        'AdmissionAbstractReport',
                                                        overAllStrengthData,
                                                        columnVisibilityData,
                                                    )
                                                }>
                                                {' '}
                                                Excel{' '}
                                            </Button>
                                        </DropdownItem>
                                        <DropdownItem>
                                            <Button
                                                color='primary'
                                                isLight
                                                icon='PictureAsPdf'
                                                onClick={() =>
                                                    convertJsonToPdf(
                                                        overAllStrengthData,
                                                        columnVisibilityData,
                                                        'AdmissionAbstractReport',
                                                    )
                                                }>
                                                {' '}
                                                PDF
                                            </Button>
                                        </DropdownItem>
                                        <DropdownItem>
                                            <Button
                                                color='primary'
                                                isLight
                                                icon='CloudDownload'
                                                onClick={() =>
                                                    downloadFile(
                                                        'AdmissionAbstractReport',
                                                        overAllStrengthData,
                                                        columnVisibilityData,
                                                    )
                                                }>
                                                {' '}
                                                CSV{' '}
                                            </Button>
                                        </DropdownItem>
                                        <DropdownItem>
                                            <Button
                                                color='primary'
                                                isLight
                                                icon='Print'
                                                onClick={handlePrint}>
                                                {' '}
                                                Print{' '}
                                            </Button>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </CardActions>
                        </CardHeader>
                        <CardBody className='table-responsive' isScrollable>
                            <table className='table table-modern table-hover text-nowrap'>
                                <thead>
                                    <tr className='table-success text-decoration-underline mt-4'>
                                        <th>S.No</th>
                                        <th>Course</th>
                                        <th>Capacity</th>
                                        {report.map((rowData2: any) => (
                                            <th key={rowData2.keyName}>{rowData2.dateOfAdmission}</th>
                                        ))}
                                        <th className='text-center'>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {report1 != '' ? (
                                        <>
                                            {report1.map((rowData: any, index: number) => (
                                                <tr key={rowData.courseId}>
                                                    <td>{rowData.sno}</td>
                                                    <td>{rowData.courseName}</td>
                                                    <td>{rowData.totalAllocated}</td>
                                                    {report.map((dateOfAdmissionData: any) => {
                                                        const admissionData = overAllStrengthData.find(
                                                            (rowData1: any) => rowData1.courseId === rowData.courseId &&
                                                                rowData1.dateOfAdmission === dateOfAdmissionData.dateOfAdmission
                                                        );
                                                        return (
                                                            <td key={dateOfAdmissionData}>
                                                                {admissionData ? admissionData.admissionCount : 0}
                                                            </td>
                                                        );
                                                    })}
                                                    <td>{totalAdmissionsPerRow[index]}</td>
                                                </tr>
                                            ))}

                                            <tr className='table-danger fx-bold'>
                                                <td colSpan={2}>Total</td>
                                                <td>{totalCapacity}</td>
                                                {report.map((dateOfAdmissionData: any) => (
                                                    <td key={dateOfAdmissionData.dateOfAdmission}>
                                                        {totalAdmissionsPerColumn[dateOfAdmissionData.dateOfAdmission]}
                                                    </td>
                                                ))}
                                                <td>{total}</td>
                                            </tr>
                                        </>
                                    ) : (
                                        <NoDataMsg columnsCount={5} msg={noDataMsg} />
                                    )}
                                </tbody>
                            </table>
                        </CardBody>
                        {/* <PaginationButtons
                            className='d-print-none'
                            data={items}
                            label='items'
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                            perPage={perPage}
                            setPerPage={setPerPage}
                        /> */}
                    </Card>
                ) : null}
            </Page>
        </PageWrapper>
    );
}
export default AdmissionAbstractReport;
